import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  userData: null,
  loading: false,
  loadingAddBalance: false,
  loadingListVouchers: false,
  loadingCreateAccount: false,
  loadingClientProfile: false,
  loadingAddCoupon: false,
  loadingWithdrawable: false,
  loadingListToken: false,
  error: "",
  totalToken: 0,
  totalVouchers: 0,
  tokenList: [],
  loadingCheckBetstop: false,
  loadingExternalWallet: false,
  loadingUserAdvance: false,
  loadingTrans: false,
  transactions: [],
  paginationTrans: {
    page: 1,
    limit: 10,
    total: -1,
  },
  loadingBet: false,
  bets: [],
  nextCursorBets: null,
  hasMoreBets: false,
  profileTypes: [],
  tasks: [],
  loadingTasks: false,
  paginationTasks: {
    page: 1,
    limit: 10,
    total: -1,
  },
  notes: [],
  loadingNotes: false,
  paginationNotes: {
    page: 1,
    limit: 10,
    total: -1,
  },
  loadingCheckBetstop: false,
  isBetstop: false,
  loadingListPromotion: false,
  paginationPromotions: {
    page: 1,
    limit: 10,
    total: -1,
  },
  loadingBreakHistories: false,
  loadingDepositHistories: false,
  paginationBreakHistories: {
    page: 1,
    limit: 10,
    total: -1,
  },
  paginationDepositHistories: {
    page: 1,
    limit: 10,
    total: -1,
  },
  paginationActivities: {
    page: 1,
    limit: 10,
    total: -1,
  },
  loadingActivities: false,
  loadingAudit: false,
  paginationAudit: {
    page: 1,
    limit: 10,
    total: -1,
  },
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    SET_USER: (s, user) => (s.userData = user),
    SET_USER_PROFILE: (s, profile) => (s.userData.profile = profile),
    LOADING: (s) => (s.loading = true),
    DELETE_BANK_ACCOUNT: (s, id) =>
      (s.userData.bankAccounts = s.userData.bankAccounts.filter(
        (b) => b.bankAccountId !== id,
      )),
    LOADING_ADD_BALANCE: (s) => (s.loadingAddBalance = true),
    LOADED_ADD_BALANCE: (s) => (s.loadingAddBalance = false),
    LOADING_CLIENT_PROFILE: (s) => (s.loadingClientProfile = true),
    LOADING_WITHDRAWABLE: (s, loading) => (s.loadingClientProfile = loading),
    LOADED_CLIENT_PROFILE: (s) => (s.loadingClientProfile = false),
    LOADING_CREATE_ACCOUNT: (s) => (s.loadingCreateAccount = true),
    LOADED_CREATE_ACCOUNT: (s) => (s.loadingCreateAccount = false),
    LOADING_ADD_COUPON: (s) => (s.loadingAddCoupon = true),
    LOADING_LIST_VOUCHER: (s, loading) => (s.loadingListVouchers = loading),

    LOADED_ADD_COUPON: (s) => (s.loadingAddCoupon = false),
    SET_TOTAL_TOKEN: (s, total) => (s.totalToken = total),
    SET_TOTAL_VOUCHER: (s, total) => (s.totalVouchers = total),

    SET_LIST_TOKEN: (s, list) => (s.tokenList = [...list]),
    LOADING_LIST_TOKEN: (s) => (s.loadingListToken = true),
    LOADED_LIST_TOKEN: (s) => (s.loadingListToken = false),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: (s) => (s.loading = false),
    LOAD_CHECK_BETSTOP: (s, data) => (s.loadingCheckBetstop = data),
    LOADING_USER_ADVANCE: (s) => (s.loadingUserAdvance = true),
    LOADED_USER_ADVANCE: (s) => (s.loadingUserAdvance = false),
    LOAD_TRANSFER: (s, data) => (s.loadingExternalWallet = data),
    LOAD_TRANSACTIONS: (s, data) => (s.loadingTrans = data),
    SET_TRANSACTIONS: (s, data) => {
      s.transactions = data.transactions;
      s.paginationTrans = data.pagination;
    },
    LOAD_BET: (s, data) => (s.loadingBet = data),
    SET_BETS: (s, data) => {
      s.bets = data.bets;
      s.nextCursorBets = data.nextCursor;
      s.hasMoreBets = data.hasMore;
    },
    APPEND_BETS: (s, data) => {
      s.bets = [...s.bets, ...data.bets];
      s.nextCursorBets = data.nextCursor;
      s.hasMoreBets = data.hasMore;
    },
    SET_PROFILE_TYPES: (s, data) => {
      s.profileTypes = data;
    },
    SET_TASKS: (s, data) => {
      s.tasks = data.tasks;
      s.paginationTasks = data.pagination;
    },
    SET_NOTES: (s, data) => {
      s.notes = data.notes;
      s.paginationNotes = data.pagination;
    },
    SET_LOADING_TASKS: (s, loading) => (s.loadingTasks = loading),
    SET_LOADING_NOTES: (s, loading) => (s.loadingNotes = loading),
    RESET: (s) => Object.assign(s, initState()),
    LOAD_CHECK_BETSTOP: (s, data) => (s.loadingCheckBetstop = data),
    SET_DATA_BETSTOP: (s, data) => (s.isBetstop = data),
    LOAD_LIST_PROMOTION: (s, data) => (s.loadingListPromotion = data),
    SET_PROMOTIONS_PAGINATION: (s, data) => (s.paginationPromotions = data),
    SET_LOADING_BREAK_HISTORIES: (s, loading) =>
      (s.loadingBreakHistories = loading),
    SET_LOADING_DEPOSIT_HISTORIES: (s, loading) =>
      (s.loadingDepositHistories = loading),
    SET_PAGINATION_BREAK_HISTORIES: (s, pagination) =>
      (s.paginationBreakHistories = pagination),
    SET_PAGINATION_DEPOSIT_HISTORIES: (s, pagination) =>
      (s.paginationDepositHistories = pagination),
    SET_LOADING_ACTIVITIES: (s, loading) => (s.loadingActivities = loading),
    SET_PAGINATION_ACTIVITIES: (s, pagination) =>
      (s.paginationActivities = pagination),
    SET_LOADING_AUDIT: (s, loading) => (s.loadingAudit = loading),
    SET_PAGINATION_AUDIT: (s, pagination) => (s.paginationAudit = pagination),
  },

  actions: {
    async asyncUser({ commit }, param) {
      commit("LOADING");
      try {
        const res = await this.$api.get(`/v1/portal/users/${param.id}`);
        if (res.data && Object.keys(res.data.data).length) {
          commit("SET_USER", res.data.data);
          return res.data.data;
        }
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED");
      }
    },

    async updateUserBalance({ commit }, param) {
      commit("LOADING_ADD_BALANCE");

      try {
        const res = await this.$api.put(
          `/v1/portal/wallets/${param.id}/update`,
          {
            amount: Number(param.amount),
          },
        );
        if (res.data && Object.keys(res.data.data).length) {
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED_ADD_BALANCE");
      }
    },
    async updateUserWithdrawal({ commit }, param) {
      commit("LOADING_WITHDRAWABLE", true);

      try {
        const res = await this.$api.put(
          `/v1/portal/wallets/${param.id}/maximum-withdrawal-value`,
          {
            amount: Number(param.amount),
          },
        );
        if (res.data && Object.keys(res.data.data).length) {
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING_WITHDRAWABLE", false);
      }
    },
    async updateClientProfile({ commit }, param) {
      commit("LOADING_CLIENT_PROFILE");

      try {
        const res = await this.$api.put(`/v1/portal/users/${param.userId}`, {
          ...param,
        });
        if (res.data && Object.keys(res.data.data).length) {
          // commit('SET_USER_PROFILE', res.data.data?.profile?.replace('_', ' '))
          commit("SET_USER", res.data.data);
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED_CLIENT_PROFILE");
      }
    },
    async createAccount({ commit }, param) {
      commit("LOADING_CREATE_ACCOUNT");

      try {
        const res = await this.$api.post("/v1/portal/users", {
          ...param,
        });
        if (res.data && Object.keys(res.data.data).length) {
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED_CREATE_ACCOUNT");
      }
    },
    async handleAddCoupon({ commit }, param) {
      commit("LOADING_ADD_COUPON");

      try {
        const res = await this.$api.post("/v1/portal/coupons/rebuy-token", {
          userIds: param.id ? [param.id] : [],
          amount: param.amount,
          userProfiles: param.profile ? [param.profile] : [],
          expiredTime: param.expiredTime,
          couponType: param.couponType,
        });
        if (res.data && Object.keys(res.data.data).length) {
          return true;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED_ADD_COUPON");
      }
    },
    async getListReBuy({ commit }, param) {
      commit("LOADING_LIST_TOKEN");
      try {
        const res = await this.$api.get("/v1/portal/coupons", {
          params: {
            userId: param.id,
            limit: param.limit,
            page: param.page ? param.page : 1,
            shouldExpired: param.shouldExpired,
            couponStatus: param.couponStatus,
            couponType: param.couponType,
            onlyCount: param.onlyCount || 0,
          },
        });
        if (res.data && Object.keys(res.data.data).length) {
          commit("SET_TOTAL_TOKEN", res.data.data.pagination.total);
          commit("SET_LIST_TOKEN", res.data.data.coupons);

          return res.data.data;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED_LIST_TOKEN");
      }
    },
    async getListVouchers({ commit }, param) {
      commit("LOADING_LIST_VOUCHER");
      try {
        const res = await this.$api.get("/v1/portal/coupons", {
          params: {
            userId: param.id,
            limit: param.limit,
            page: param.page ? param.page : 1,
            shouldExpired: param.shouldExpired,
            couponStatus: param.couponStatus,
            couponType: param.couponType,
            onlyCount: param.onlyCount || 0,
          },
        });
        if (res.data && Object.keys(res.data.data).length) {
          commit("SET_TOTAL_VOUCHER", res.data.data.pagination.total);

          return res.data.data;
        }
        return false;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING_LIST_VOUCHER");
      }
    },

    async handleCheckBetstop({ commit }, params) {
      commit("LOAD_CHECK_BETSTOP", true);

      try {
        const res = await this.$api.post("/portal/bet-stop", {
          firstName: params.firstName,
          lastName: params.lastName,
          dob: params.dob,
          email: params.email,
          phoneNumber: params.phoneNumber,
          postCode: params.postCode,
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CHECK_BETSTOP", false);
      }
    },

    async transferExternalWallet({ commit }, params) {
      commit("LOAD_TRANSFER", true);
      try {
        const res = await this.$api.post("/portal/wallet/transfer", params);
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_TRANSFER", false);
      }
    },
    async withdrawExternalWallet({ commit }, params) {
      commit("LOAD_TRANSFER", true);
      try {
        const res = await this.$api.post(
          "/v2/portal/withdrawal-requests",
          params,
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_TRANSFER", false);
      }
    },
    async getTransactionByUser({ commit }, params) {
      commit("LOAD_TRANSACTIONS", true);
      try {
        const res = await this.$api.get("/v1/portal/transactions", { params });
        const { data, pagination } = res.data;
        commit("SET_TRANSACTIONS", {
          users: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_TRANSACTIONS", false);
      }
    },
    async getBetslipById(_, { userId, id }) {
      try {
        const res = await this.$api.get("/v1/portal/betslips", {
          params: { userId, id, limit: 1 },
        });
        return (res.data.data || [])[0] || null;
      } catch (e) {
        errorHandler(e);
        return null;
      }
    },
    async getBettingHistoryByUser({ commit }, params) {
      commit("LOAD_BET", true);
      try {
        const res = await this.$api.get("/v1/portal/betslips", { params });
        const { data, metadata } = res.data;
        commit("SET_BETS", {
          bets: data || [],
          nextCursor: metadata?.nextCursor || null,
          hasMore: metadata?.hasMore || false,
        });
        return data || [];
      } catch (e) {
        errorHandler(e);
        return [];
      } finally {
        commit("LOAD_BET", false);
      }
    },
    async loadMoreBettingHistoryByUser({ commit, state }, params) {
      if (state.loadingBet || !state.hasMoreBets) return [];
      commit("LOAD_BET", true);
      try {
        const res = await this.$api.get("/v1/portal/betslips", {
          params: { ...params, cursor: state.nextCursorBets },
        });
        const { data, metadata } = res.data;
        commit("APPEND_BETS", {
          bets: data || [],
          nextCursor: metadata?.nextCursor || null,
          hasMore: metadata?.hasMore || false,
        });
        return data || [];
      } catch (e) {
        errorHandler(e);
        return [];
      } finally {
        commit("LOAD_BET", false);
      }
    },

    async getProfileTypes({ commit }) {
      try {
        const { data: res } = await this.$api.get(`/v1/profile-types`);
        commit("SET_PROFILE_TYPES", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async resetPassword({ commit }, { userId, password }) {
      try {
        const res = await this.$api.put(
          `/v1/portal/users/${userId}/reset-password`,
          { password },
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getTasksByUser({ commit }, params) {
      commit("SET_LOADING_TASKS", true);
      try {
        const res = await this.$api.get("/v1/portal/tasks", { params });
        const { data, pagination } = res.data;
        commit("SET_TASKS", {
          tasks: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_TASKS", false);
      }
    },
    async getNotesByUser({ commit }, params) {
      commit("SET_LOADING_NOTES", true);
      try {
        const res = await this.$api.get("/v1/portal/notes", { params });
        const { data, pagination } = res.data;
        commit("SET_NOTES", {
          notes: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_NOTES", false);
      }
    },
    async addTask({ commit }, payload) {
      try {
        const res = await this.$api.post("/v1/portal/tasks", payload);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateTask({ commit, state }, payload) {
      try {
        const { taskId, ...data } = payload;
        const { data: res } = await this.$api.put(
          `/v1/portal/tasks/${taskId}`,
          data,
        );
        if (!res.data) return;
        const updatedTaskIndex = state.tasks.findIndex(
          (t) => t.taskId === taskId,
        );
        if (updatedTaskIndex !== -1) {
          const updatedTasks = [...state.tasks];
          updatedTasks[updatedTaskIndex] = {
            ...updatedTasks[updatedTaskIndex],
            ...data,
          };
          commit("SET_TASKS", { tasks: updatedTasks });
        }
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async addNote({ commit }, payload) {
      try {
        const res = await this.$api.post("/v1/portal/notes", payload);
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateNote({ commit, state }, payload) {
      try {
        const { noteId, ...data } = payload;
        const { data: res } = await this.$api.put(
          `/v1/portal/notes/${noteId}`,
          data,
        );
        if (!res.data) return;
        const updatedNoteIndex = state.notes.findIndex(
          (n) => n.noteId === noteId,
        );
        if (updatedNoteIndex !== -1) {
          const updatedNotes = [...state.notes];
          updatedNotes[updatedNoteIndex] = {
            ...updatedNotes[updatedNoteIndex],
            ...data,
          };
          commit("SET_NOTES", { notes: updatedNotes });
        }
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async checkBetstop({ commit }, userId) {
      commit("LOAD_CHECK_BETSTOP", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/users/${userId}/bet-stop/verify`,
        );
        commit("SET_DATA_BETSTOP", !res.data.data.verified);

        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CHECK_BETSTOP", false);
      }
    },
    async getDepositMatches({ commit }, params) {
      commit("LOAD_LIST_PROMOTION", true);
      try {
        const { userId, page } = params;
        const res = await this.$api.get(
          `/v1/portal/promotions/${userId}/deposit`,
          {
            params: {
              page,
            },
          },
        );
        commit("SET_PROMOTIONS_PAGINATION", res.data.pagination);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_PROMOTION", false);
      }
    },
    async getBonusCreditHistory({ commit }, { userId, ...params }) {
      try {
        const { data: res } = await this.$api.get(
          `/v1/portal/users/${userId}/bonus-credit-history`,
          { params },
        );
        return res;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getDepositLimitByUser({ commit }, userId) {
      try {
        const { data: res } = await this.$api.get(
          `/v1/portal/users/${userId}/deposit-limit`,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getBreakHistoryByUser({ commit }, params) {
      try {
        commit("SET_LOADING_BREAK_HISTORIES", true);
        const { userId, ...restParams } = params;
        const res = await this.$api.get(
          `/v1/portal/users/${userId}/break-histories`,
          { params: restParams },
        );
        const { data, pagination } = res.data;
        commit("SET_PAGINATION_BREAK_HISTORIES", pagination);
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_BREAK_HISTORIES", false);
      }
    },
    async getDepositsHistoryByUser({ commit }, params) {
      try {
        commit("SET_LOADING_DEPOSIT_HISTORIES", true);
        const { userId, ...restParams } = params;
        const res = await this.$api.get(
          `/v1/portal/users/${userId}/deposit-limit-histories`,
          { params: restParams },
        );
        const { data, pagination } = res.data;
        commit("SET_PAGINATION_DEPOSIT_HISTORIES", pagination);
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_DEPOSIT_HISTORIES", false);
      }
    },

    async getActivityLogsByUser({ commit }, params) {
      try {
        commit("SET_LOADING_ACTIVITIES", true);
        const res = await this.$api.get(`/v1/portal/activity-logs`, {
          params,
        });
        const { data, pagination } = res.data;
        commit("SET_PAGINATION_ACTIVITIES", pagination);
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_ACTIVITIES", false);
      }
    },
    async getAuditLogsByUser({ commit }, params) {
      try {
        commit("SET_LOADING_AUDIT", true);
        const res = await this.$api.get(`/v1/portal/audit-logs`, {
          params,
        });
        const { data, pagination } = res.data;
        commit("SET_PAGINATION_AUDIT", pagination);
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_AUDIT", false);
      }
    },
    async changePasswordUser({ commit }, { userId, password }) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/users/${userId}/change-password`,
          { password },
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getUserRevenue(_ctx, userId) {
      try {
        const { data: res } = await this.$api.get(
          `/v1/portal/users/${userId}/revenue`,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getBettingTemplates({ commit }, tag) {
      try {
        const { data: res } = await this.$api.get('/v1/portal/profile-configs/', {
          params: tag ? { tag } : {},
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateBettingTemplate({ commit }, { userId, bettingTemplate }) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/users/${userId}/betting-template`,
          { bettingTemplate },
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateUserAdvance({ commit }, { userId, ...payload }) {
      commit("LOADING_USER_ADVANCE");
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/users/${userId}/advance`,
          payload,
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED_USER_ADVANCE");
      }
    },
    async getBoostedPromotions({ commit }, payload) {
      try {
        const { userId, ...restPayload } = payload;
        const { data: res } = await this.$api.get(
          `/v1/portal/promotions/users/${userId}`,
          {
            params: {
              ...restPayload,
            },
          },
        );
        return {
          data: res.data,
          pagination: res.pagination,
        };
      } catch (e) {
        errorHandler(e);
      }
    },
  },
};
